<template>
  <div>
    <v-form ref="cashiersForm">
      <v-row>
        <v-col cols="12" md="12">
          <p class="text-h6">Informacion General</p>
        </v-col>
        <v-col class="mt-n5" cols="12" md="12">
          <v-text-field
            v-model="data.Nomb"
            :rules="rules.name"
            label="Nombre"
            outlined
            dense
            required
          ></v-text-field>
        </v-col>
        <v-col class="mt-n7" cols="12" md="12">
          <v-text-field
            v-model="data.Cve"
            :rules="rules.Cve"
            label="Clave"
            outlined
            dense
            required
          ></v-text-field>
        </v-col>
        <v-col class="mt-n7" cols="12" md="12">
          <v-text-field
            v-model="data.NM"
            :rules="rules.NM"
            type="number"
            label="Numero de personas"
            outlined
            dense
            required
          ></v-text-field>
        </v-col>
        <v-divider></v-divider>
        <v-col class="mt-n5" cols="12" md="12">
          <p class="text-h6">Costos e Intereses</p>
        </v-col>
        <v-col v-if="false" cols="12" md="6">
          <v-text-field
            v-model.number="data.CPA.C"
            :rules="rules.CPA.C"
            type="number"
            label="Comisión por apertura"
            outlined
            dense
            required
          ></v-text-field>
        </v-col>
        <v-col v-if="false" cols="12" md="6">
          <v-select
            v-model="data.CPA.M"
            :items="monedas"
            item-value="id"
            item-text="Nombre"
            label="Moneda Comisión por apertura Apertura"
            outlined
            dense
            required
          ></v-select>
        </v-col>
        <v-col class="mt-n5" cols="12" md="6">
          <v-text-field
            v-model.number="data.CA.C"
            :rules="rules.CA.C"
            type="number"
            label="Costo Anual"
            outlined
            dense
            required
          ></v-text-field>
        </v-col>
        <v-col class="mt-n5" cols="12" md="6">
          <v-select
            :items="monedas"
            item-value="id"
            item-text="Nombre"
            v-model="data.CA.M"
            label="Moneda Costo Anual"
            outlined
            dense
            required
          ></v-select>
        </v-col>
        <v-col class="mt-n7" cols="12" md="12">
          <v-text-field
            v-model.number="data.TIA"
            :rules="rules.TIA"
            type="number"
            label="Tasa de Interes Anual"
            outlined
            dense
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="mt-n7" cols="2">
          <v-switch v-model="data.Activo" label="Activo"></v-switch>
        </v-col>
      </v-row>
      <div class="text-right">
        <v-btn large @click="$emit('toggle', false)">Cancelar</v-btn>
        <v-btn style="margin-left: 6px" color="success" large @click="checkForm"
          >Guardar</v-btn
        >
      </div>
    </v-form>
  </div>
</template>

<style scoped></style>

<script>
import Currency from "../../clases/Currencies.js";
export default {
  name: "FormMembresia",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      currencyClass: Currency,
      monedas: [],
      data: {
        Activo: true,
        Id: null,
        CA: { C: null, M: "MXN" },
        CPA: { C: null, M: "MXN" },
        Mnd: "MXN",
        Nomb: null,
        Cve: "",
        TIA: null,
        NM: 1,
      },
      rules: {
        Cve: [(value) => !!value || "La clave es obligatoria"],
        name: [(value) => !!value || "El Nombre es obligatorio"],
        CA: { C: [(value) => value >= 0 || "El costo anual es obligatorio"] },
        CPA: {
          C: [
            (value) => value >= 0 || "La comisión por apertura es obligatoria",
          ],
        },
        NM: [(value) => value >= 0 || "El numero de personas es requerido"],
        TIA: [(value) => value >= 0 || "La tasa de interes anual es requerida"],
      },
    };
  },
  methods: {
    checkForm() {
      if (this.$refs.cashiersForm.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.send(doAction);
      }
    },
    send(action) {
      const dataSave = this.data;
      dataSave.CA.C = Number(dataSave.CA.C);
      dataSave.CPA.C = Number(dataSave.CPA.C);
      dataSave.NM = Number(dataSave.NM);
      dataSave.TIA = Number(dataSave.TIA);
      if (action === "EDIT") {
        // id de edicion
        dataSave.Id = this.dataEdit.id;
      }

      this.$emit("successData", dataSave, action);
    },
  },
  mounted() {
    //localStorage.getItem("selectedDepartment");
    this.monedas = this.currencyClass.getCurrencies();

    if (this.edit) {
      this.Id = this.dataEdit.id;
      (this.data.Nomb = this.dataEdit.Nomb),
        (this.data.Activo = this.dataEdit.Activo),
        (this.data.CA.C = this.dataEdit.CA.C),
        (this.data.CA.M = this.dataEdit.CA.M),
        (this.data.CPA.C = this.dataEdit.CPA.C),
        (this.data.NM = this.dataEdit.NM),
        (this.data.CPA.M = this.dataEdit.CPA.M);
      this.data.TIA = this.dataEdit.TIA;
      this.data.Cve = this.dataEdit.Cve;
    }
  },
};
</script>
